// eslint-disable-next-line no-undef
IntlPolyfill.__addLocaleData({
  locale: 'ar',
  date: {
    ca: ['gregory', 'generic'],
    hourNo0: true,
    hour12: true,
    formats: {
      short: '{1} {0}',
      medium: '{1} {0}',
      full: '{1} {0}',
      long: '{1} {0}',
      availableFormats: {
        d: 'd',
        E: 'ccc',
        Ed: 'E، d',
        Ehm: 'E h:mm a',
        EHm: 'E HH:mm',
        Ehms: 'E h:mm:ss a',
        EHms: 'E HH:mm:ss',
        Gy: 'y G',
        GyMMM: 'MMM y G',
        GyMMMd: 'd MMM، y G',
        GyMMMEd: 'E، d MMM، y G',
        h: 'h a',
        H: 'HH',
        hm: 'h:mm a',
        Hm: 'HH:mm',
        hms: 'h:mm:ss a',
        Hms: 'HH:mm:ss',
        hmsv: 'h:mm:ss a v',
        Hmsv: 'HH:mm:ss v',
        hmv: 'h:mm a v',
        Hmv: 'HH:mm v',
        M: 'L',
        Md: 'd/‏M',
        MEd: 'E، d/M',
        MMdd: 'dd‏/MM',
        MMM: 'LLL',
        MMMd: 'd MMM',
        MMMEd: 'E، d MMM',
        MMMMd: 'd MMMM',
        MMMMEd: 'E، d MMMM',
        ms: 'mm:ss',
        y: 'y',
        yM: 'M‏/y',
        yMd: 'd‏/M‏/y',
        yMEd: 'E، d/‏M/‏y',
        yMM: 'MM‏/y',
        yMMM: 'MMM y',
        yMMMd: 'd MMM، y',
        yMMMEd: 'E، d MMM، y',
        yMMMM: 'MMMM y',
        yQQQ: 'QQQ y',
        yQQQQ: 'QQQQ y',
      },
      dateFormats: {
        yMMMMEEEEd: 'EEEE، d MMMM، y',
        yMMMMd: 'd MMMM، y',
        yMMMd: 'dd‏/MM‏/y',
        yMd: 'd‏/M‏/y',
      },
      timeFormats: {
        hmmsszzzz: 'h:mm:ss a zzzz',
        hmsz: 'h:mm:ss a z',
        hms: 'h:mm:ss a',
        hm: 'h:mm a',
      },
    },
    calendars: {
      generic: {
        months: {
          narrow: [
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12',
          ],
          short: [
            'M01',
            'M02',
            'M03',
            'M04',
            'M05',
            'M06',
            'M07',
            'M08',
            'M09',
            'M10',
            'M11',
            'M12',
          ],
          long: [
            'M01',
            'M02',
            'M03',
            'M04',
            'M05',
            'M06',
            'M07',
            'M08',
            'M09',
            'M10',
            'M11',
            'M12',
          ],
        },
        days: {
          narrow: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
          short: [
            'الأحد',
            'الاثنين',
            'الثلاثاء',
            'الأربعاء',
            'الخميس',
            'الجمعة',
            'السبت',
          ],
          long: [
            'الأحد',
            'الاثنين',
            'الثلاثاء',
            'الأربعاء',
            'الخميس',
            'الجمعة',
            'السبت',
          ],
        },
        eras: {
          narrow: ['ERA0', 'ERA1'],
          short: ['ERA0', 'ERA1'],
          long: ['ERA0', 'ERA1'],
        },
        dayPeriods: {
          am: 'ص',
          pm: 'م',
        },
      },
      gregory: {
        months: {
          narrow: ['ي', 'ف', 'م', 'أ', 'و', 'ن', 'ل', 'غ', 'س', 'ك', 'ب', 'د'],
          short: [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
          ],
          long: [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
          ],
        },
        days: {
          narrow: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
          short: [
            'الأحد',
            'الاثنين',
            'الثلاثاء',
            'الأربعاء',
            'الخميس',
            'الجمعة',
            'السبت',
          ],
          long: [
            'الأحد',
            'الاثنين',
            'الثلاثاء',
            'الأربعاء',
            'الخميس',
            'الجمعة',
            'السبت',
          ],
        },
        eras: {
          narrow: ['ق.م', 'م', 'BCE', 'ب.م'],
          short: ['ق.م', 'م', 'BCE', 'ب.م'],
          long: ['قبل الميلاد', 'ميلادي', 'BCE', 'بعد الميلاد'],
        },
        dayPeriods: {
          am: 'ص',
          pm: 'م',
        },
      },
    },
  },
  number: {
    nu: ['arab', 'latn'],
    patterns: {
      decimal: {
        positivePattern: '{number}',
        negativePattern: '{minusSign}{number}',
      },
      currency: {
        positivePattern: '{currency} {number}',
        negativePattern: '{minusSign}{currency} {number}',
      },
      percent: {
        positivePattern: '{number}{percentSign}',
        negativePattern: '{minusSign}{number}{percentSign}',
      },
    },
    symbols: {
      arab: {
        decimal: '٫',
        group: '٬',
        nan: 'ليس رقم',
        plusSign: '‏+',
        minusSign: '‏-',
        percentSign: '٪',
        infinity: '∞',
      },
      latn: {
        decimal: '.',
        group: ',',
        nan: 'ليس رقمًا',
        plusSign: '‎+',
        minusSign: '‎-',
        percentSign: '٪',
        infinity: '∞',
      },
    },
    currencies: {
      AED: 'د.إ.‏',
      AUD: 'AU$',
      BHD: 'د.ب.‏',
      BRL: 'R$',
      CAD: 'CA$',
      CNY: 'CN¥',
      DZD: 'د.ج.‏',
      EGP: 'ج.م.‏',
      EUR: '€',
      GBP: '£',
      HKD: 'HK$',
      IDR: 'ر.إن.',
      ILS: '₪',
      INR: '₹',
      IQD: 'د.ع.‏',
      IRR: 'ر.إ.',
      JOD: 'د.أ.‏',
      JPY: 'JP¥',
      KMF: 'ف.ج.ق.‏',
      KRW: '₩',
      KWD: 'د.ك.‏',
      LBP: 'ل.ل.‏',
      LYD: 'د.ل.‏',
      MAD: 'د.م.‏',
      MRO: 'أ.م.‏',
      MXN: 'MX$',
      NZD: 'NZ$',
      OMR: 'ر.ع.‏',
      PKR: 'ر.ب.',
      QAR: 'ر.ق.‏',
      SAR: 'ر.س.‏',
      SDD: 'د.س.‏',
      SDG: 'ج.س.',
      SSP: 'ج.ج.س.',
      SYP: 'ل.س.‏',
      THB: '฿',
      TND: 'د.ت.‏',
      TRY: 'ل.ت.',
      TWD: 'NT$',
      USD: 'US$',
      VND: '₫',
      XAF: 'FCFA',
      XCD: 'EC$',
      XOF: 'CFA',
      XPF: 'CFPF',
      XXX: '***',
      YER: 'ر.ي.‏',
    },
  },
})
